/** @jsx jsx */

import { isEmpty, startCase, get } from 'lodash';

import { Grid, Icon, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import {
  checkMap,
  iconsMap,
} from 'app/developer-v3/components/SidebarRight/constants';

import DetailItem from './DetailItem';

import type {
  ImplementationValidationCheck,
  ValidationFailureResult,
} from 'app/developer-v3/types';

const Styles = {
  issueDetails: css`
    margin-bottom: 20px;
  `,
  issuesList: css`
    margin-top: 20px;
  `,
};

type Props = {
  type: 'errors' | 'warnings';
  checks: Array<ImplementationValidationCheck>;
  handleDetailsClick: (
    result: ValidationFailureResult,
    type: string,
    checkType: string,
    violation: string
  ) => void;
};

const DetailsList = (props: Props) =>
  !isEmpty(props.checks) && (
    <ul
      aria-label={`Validation ${startCase(props.type)} List`}
      css={Styles.issuesList}
    >
      {props.checks.map(check =>
        get(check, 'violations', []).map(violation => (
          <li
            aria-label="Validation Issue"
            css={Styles.issueDetails}
            key={`${props.type}-${violation.type}`}
          >
            <Grid alignItems="center" columns="repeat(2, auto) 1fr" gap={5}>
              <Icon
                color={iconsMap.errors.color}
                name={iconsMap[props.type].name}
                size={20}
              />
              <Text fontWeight={600}>{checkMap[check.type]}</Text>{' '}
              <Text>({violation.type})</Text>
            </Grid>
            <Spacer height={20} />
            <ul>
              {violation.results.map((result, idxResult) => (
                <li aria-label="Validation Details" key={idxResult}>
                  <DetailItem
                    message={result.message}
                    onClick={() =>
                      props.handleDetailsClick(
                        result,
                        props.type,
                        check.type,
                        violation.type
                      )
                    }
                  />
                </li>
              ))}
            </ul>
          </li>
        ))
      )}
    </ul>
  );

export default DetailsList;
